import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useParams } from 'react-router';

import { Box, Paper, Grid, FormControl, Autocomplete, TextField, InputBase, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Typography, TableFooter, TablePagination, TablePaginationActions, List, ListItem, ListItemText, Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions, Tooltip } from '@mui/material';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';

import { usePages } from '../../../hooks/usePages';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { DialogNuevaPersona } from '../../../dialogs/DialogNuevaPersona';
import { DialogBuscarPersona } from '../../../dialogs/DialogBuscarPersona';
import { DialogAgregarDomicilio } from '../../../dialogs/DialogAgregarDomicilio';

import { TableTheadStyle, TablePaddingStyle } from '../../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../../styles/DialogStyle';
import { InputSearchStyle, InputSearchButtonsStyle } from '../../../styles/FormStyle';

import { GuardarDestinatarios } from '../../../connections/tribunal/OficioConnection';
import { ObtenerDependencias, ObtenerDomicilioDependencia } from '../../../connections/catalogos/DependenciaConnection';

import { DestinatarioProps } from '../../../interfaces/tribunal/OficioInterface';
import { defaultPersonaBusqueda, PersonaBusquedaProps } from '../../../interfaces/comun/PersonaInterface';
import { defaultDependencia, DependenciaProps } from '../../../interfaces/catalogos/DependenciaInterface';
import { defaultDomicilio, DomicilioProps } from '../../../interfaces/comun/DomicilioInterface';

interface Props {
    edit?: boolean;
    destinatarios: DestinatarioProps[];
    setDestinatarios: React.Dispatch<React.SetStateAction<DestinatarioProps[]>>;
    dependencia?: DependenciaProps;
    setDependencia: React.Dispatch<React.SetStateAction<DependenciaProps>>;
    cumplimientoEjecutoria?: boolean;
    setTieneDomicilioDependencia?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Destinatarios = ({ edit = true, destinatarios, setDestinatarios, dependencia, setDependencia, cumplimientoEjecutoria = false, setTieneDomicilioDependencia }: Props) => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const [openDialogNuevaPersona, setOpenDialogNuevaPersona] = useState( false );
    const [openDialogBuscarPersona, setOpenDialogBuscarPersona] = useState( false );
    const [openConfirmacionEliminar, setOpenConfirmacionEliminar] = useState( false );
    const [openDialogDomicilio, setOpenDialogDomicilio] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [personaBusqueda, setPersonaBusqueda] = useState<PersonaBusquedaProps>( defaultPersonaBusqueda );

    const [rows, setRows] = useState<DestinatarioProps[]>( [] );

    const [idReferencia, setReferencia] = useState( 0 );

    const [dependeciaArray, setDependenciaArray] = useState<DependenciaProps[]>( [] );

    const [autocompleteValue, setAutocompleteValue] = useState<DependenciaProps>( defaultDependencia );

    const [domicilioDependencia, setDomicilioDependencia] = useState<DomicilioProps>( defaultDomicilio );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const { nombreCompleto } = personaBusqueda;

    const seleccionarPersona = ( persona: PersonaBusquedaProps ) => setPersonaBusqueda( persona )

    const handleGuardarDestinatarios = async () => {

        if ( cumplimientoEjecutoria && autocompleteValue.idDependencia === 0 ) {

            dispatch(openSnackbar({ message: 'Debes seleccionar la dependencia a notificar', variant: 'warning' }));
            return;

        }

        if ( cumplimientoEjecutoria && !domicilioDependencia.idDomicilio ) {

            dispatch(openSnackbar({ message: 'La dependencia no tiene un domicilio registrado, agrégalo antes de guardar', variant: 'warning' }));
            return;

        }

        setLoadingGuardar(true);

        await GuardarDestinatarios({ idOficio: Id ?? "", idDependencia: autocompleteValue.idDependencia, destinatarios: rows }).then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch(openSnackbar({ message: message, variant: 'success' }));
                    setLoadingGuardar(false);

                    setDestinatarios( rows )

                    setDependencia( autocompleteValue );
                }
                else {

                    dispatch(openSnackbar({ message, variant: 'error' }));
                    setLoadingGuardar(false);

                }

            }, 700);
        });
    }

    const handleAgregarDestinatario = () => {

        if ( nombreCompleto !== '' ) {

            const personaValidate = rows.find((element) => element.idPersona === personaBusqueda.idPersona );

            if ( !personaValidate ) {

                setRows([...rows, personaBusqueda]);

            }
            else {

                dispatch(openSnackbar({ message: 'La persona ya se encuentra agregada', variant: 'warning' }));

            }

            setPersonaBusqueda( defaultPersonaBusqueda );

        }
        else {

            dispatch(openSnackbar({ message: 'Debe seleccionar una persona', variant: 'warning' }));

        }

    }

    const handleClicEliminarParte = ( id: number ) => {

        setReferencia( id );

        setOpenConfirmacionEliminar( true );

    }

    const eliminarParte = () => {

        var newArray = rows.filter( ( elem ) => elem.idPersona !== idReferencia );

        if ( page > 0 && page * rowsPerPage >= newArray.length ) {
            resetPage();
        }

        setRows( newArray );

        setOpenConfirmacionEliminar( false );

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerDependencias().then( resp  => {
                setDependenciaArray( resp )
            })
        }

        Obtener();

    }, []);

    useEffect(() => {

        setRows( destinatarios );
        setAutocompleteValue( dependencia ?? defaultDependencia );

    }, [ destinatarios, dependencia ]);

    useEffect(() => {

        async function Obtener() {

            if ( openDialogDomicilio ) {
                return;
            }

            setDomicilioDependencia( defaultDomicilio );

            if ( cumplimientoEjecutoria && autocompleteValue.idDependencia !== 0 ) {

                await ObtenerDomicilioDependencia( autocompleteValue.idDependencia ).then(resp => {
                    setDomicilioDependencia( resp[0] ?? defaultDomicilio );
                });

            }

        }

        Obtener();

    }, [ cumplimientoEjecutoria, autocompleteValue.idDependencia, openDialogDomicilio ]);

    useEffect(() => {

        // Solo cuenta el domicilio de la dependencia ya guardada en el oficio, no la que está seleccionada sin guardar
        if ( autocompleteValue.idDependencia === ( dependencia?.idDependencia ?? 0 ) ) {
            setTieneDomicilioDependencia?.( !!domicilioDependencia.idDomicilio );
        }

    }, [ autocompleteValue.idDependencia, dependencia?.idDependencia, domicilioDependencia.idDomicilio, setTieneDomicilioDependencia ]);

    const { descripcion: calleDomicilio, numero: numeroDomicilio, asentamiento: asentamientoDomicilio } = domicilioDependencia;

    const textoDomicilioDependencia = domicilioDependencia.idDomicilio
        ? `${ calleDomicilio } #${ numeroDomicilio ?? '' }, Col. ${ asentamientoDomicilio?.descripcion }, C.P ${ asentamientoDomicilio?.codigoPostal }, ${ asentamientoDomicilio?.municipio?.descripcion }, ${ asentamientoDomicilio?.estado?.descripcion }`
        : 'La dependencia no tiene un domicilio registrado';

    return (
        <Box p={ 4 } component={ Paper }>

            <Grid container spacing={ 3 } mt={ 1 }>

                {
                    edit
                    &&
                        <>

                            <Grid size={{ md: 12, xs: 12 }} display='flex' alignItems='flex-start' gap={ 1 }>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        disablePortal
                                        fullWidth
                                        value={ autocompleteValue }
                                        options={ dependeciaArray }
                                        onChange={ (event, value) => { setAutocompleteValue(value ?? defaultDependencia); } }
                                        getOptionLabel={ (option) => option.descripcion }
                                        isOptionEqualToValue={ (option, value) => option.idDependencia === value.idDependencia }
                                        renderOption={(props, option) => (
                                            <li {...props} key={ option.idDependencia } >
                                                {option.descripcion}
                                            </li>
                                        )}
                                        renderInput={ (params) => (
                                            <TextField
                                                {...params}
                                                label='Dependencia(s)'
                                                sx={{ '& .MuiFormHelperText-root': { mt: 1.5, mx: 0.5 } }}
                                                helperText={ ( cumplimientoEjecutoria && autocompleteValue.idDependencia !== 0 ) ? `Domicilio a notificar: ${ textoDomicilioDependencia }` : undefined }
                                            />
                                        )}
                                    />
                                </FormControl>

                                {
                                    cumplimientoEjecutoria
                                    &&
                                        <Tooltip title='Agregar domicilio de la dependencia'>
                                            <span>
                                                <IconButton color='primary' sx={{ mt: 1 }} disabled={ autocompleteValue.idDependencia === 0 } onClick={ () => setOpenDialogDomicilio( true ) }>
                                                    <EditLocationAltIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                }

                            </Grid>

                            <Grid size={{ md: 10, xs: 12 }}>

                                <Paper component='div' sx={ InputSearchStyle } >

                                    <InputBase
                                        sx={{ ml: 1, flex: 1 }}
                                        inputProps={{ 'aria-label': 'Buscar persona' }}
                                        placeholder='Buscar persona'
                                        name='solicitante'
                                        value={ nombreCompleto }
                                        onChange={ () => { } }
                                        autoComplete='off'
                                        disabled
                                    />

                                    <Button
                                        size='small'
                                        variant='contained'
                                        sx={ InputSearchButtonsStyle }
                                        onClick={ () => setOpenDialogBuscarPersona(true) }
                                    >
                                        <SearchIcon />
                                    </Button>

                                    <Button
                                        variant='contained'
                                        size='small'
                                        sx={ InputSearchButtonsStyle }
                                        onClick={ () => setOpenDialogNuevaPersona(true) }
                                    >
                                        <PersonAddIcon />
                                    </Button>

                                </Paper>

                            </Grid>

                            <Grid size={{ md: 2, xs: 12 }}>
                                <Button
                                    fullWidth
                                    onClick={ handleAgregarDestinatario }
                                    variant='contained'
                                >
                                    Agregar destinatario
                                </Button>
                            </Grid>

                        </>
                }

                {
                    !edit
                    &&
                        <Grid size={{ md: 12, xs: 12 }}>

                            <List disablePadding>

                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Dependencia </Typography> }
                                        secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { dependencia?.descripcion } </Typography> }
                                    />

                                </ListItem>

                                {
                                    ( cumplimientoEjecutoria && autocompleteValue.idDependencia !== 0 )
                                    &&
                                        <ListItem sx={{ py: 0, px: 0, mt: 2 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Domicilio a notificar </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { textoDomicilioDependencia } </Typography> }
                                            />

                                        </ListItem>
                                }

                            </List>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }}>

                        <Table>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '70%', fontWeight: 'bold' }}>Nombre del destinatario</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    (
                                        rowsPerPage > 0
                                        ?
                                            rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        :
                                            rows
                                    ).map(({ nombreCompleto, idPersona }) => (

                                        <TableRow key={ idPersona } >

                                            <TableCell sx={{ fontWeight: 'Bold' }} >{nombreCompleto}</TableCell>

                                            <TableCell sx={{ textAlign: 'end' }}>

                                            {
                                                edit
                                                &&
                                                    <IconButton color='primary' onClick={ () => handleClicEliminarParte( idPersona ) }>
                                                        <DeleteIcon />
                                                    </IconButton>
                                            }

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    rows.length === 0
                                    &&
                                        <TableRow>

                                            <TableCell
                                                colSpan={ 2 }
                                                align='center'
                                            >
                                                <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>
                                            </TableCell>

                                        </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 1 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: {rows.length} </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 1 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ rows.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

                {
                    edit
                    &&
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center' }}>

                                    <Button
                                        fullWidth
                                        variant='contained'
                                        onClick={ handleGuardarDestinatarios }
                                        loading={ loadingGuardar }
                                    >
                                        Guardar destinatarios
                                    </Button>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'left' }}> </Grid>

                            </Grid>

                        </Grid>
                }

            </Grid>

            <Dialog
                fullWidth
                maxWidth='xs'
                open={ openConfirmacionEliminar }
                onClose={ () => { } }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <DialogContentText>
                        ¿Desea eliminar el destinatario seleccionado?
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" onClick={ () => setOpenConfirmacionEliminar(false) }> Cancelar </Button>
                    <Button onClick={ eliminarParte } variant='contained' > Aceptar </Button>
                </DialogActions>
            </Dialog>

            <DialogNuevaPersona
                openDialog={ openDialogNuevaPersona }
                handleCloseDialog={ () => setOpenDialogNuevaPersona(false) }
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona }
                handleCloseDialog={ () => setOpenDialogBuscarPersona(false) }
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogAgregarDomicilio
                openDialog={ openDialogDomicilio }
                handleCloseDialog={ () => setOpenDialogDomicilio(false) }
                idPersona={ 0 }
                idDependencia={ autocompleteValue.idDependencia }
                idDomicilio={ domicilioDependencia.idDomicilio ?? 0 }
                SeleccionarDomicilio={ setDomicilioDependencia }
            />

        </Box>
    )
}